import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import './imageSlider.css';

class ImageSlider extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      current: 0,
    };

    this.interval = setInterval(() => {
      this.setState({
        current: (this.state.current + 1) % this.props.images.length,
      });
    }, 3000);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  render() {
    return (
      <div className="image-slider">
        {this.props.images.map((item, idx) => {
          if (item.url) {
            return (
              <a
                href={item.url}
                title={item.label}
                target="_blank"
                key={idx}
                className={cx('image', { active: this.state.current === idx })}
                style={{ backgroundImage: 'url(' + item.image + ')' }}
              >{null}</a>
            );
          } else {
            return (
              <div
                title={item.label}
                key={idx}
                className={cx('image', { active: this.state.current === idx })}
                style={{ backgroundImage: 'url(' + item.image + ')' }}
              />
            );
          }
        })}
        <ul className="bullets">
          {this.props.images.map((item, idx) => {
            return (
              <li
                key={idx}
                onClick={() => this.setState({ current: idx })}
                className={cx({ active: this.state.current === idx })}
              >
                &nbsp;
              </li>
            );
          })}
        </ul>
      </div>
    );
  }
}

ImageSlider.defaultProps = {
  images: [],
};

ImageSlider.propTypes = {
  images: PropTypes.arrayOf(
    PropTypes.shape({
      image: PropTypes.string.isRequired,
      url: PropTypes.string,
      label: PropTypes.string,
    }),
  ).isRequired,
};

export default ImageSlider;



// WEBPACK FOOTER //
// ./src/app/component/imageSlider/imageSlider.js